"use client";

import { useState } from "react";

interface FaqItemProps {
  question: string;
  answer: string;
}

export function FaqItem({ question, answer }: FaqItemProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-current/22 py-5">
      <button
        type="button"
        className="group flex w-full items-start justify-between gap-4 text-left transition-colors"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="text-base font-semibold leading-snug sm:text-lg">
          {question}
        </span>
        <span
          className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
            open
              ? "rotate-180 border-coral/40 bg-coral/10"
              : "border-current/22 group-hover:border-coral/40"
          }`}
          aria-hidden="true"
        >
          <svg
            className={`h-4 w-4 transition-colors ${open ? "text-coral" : "opacity-70"}`}
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </span>
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-out ${
          open ? "grid-rows-[1fr] mt-4 opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="pr-12 text-sm leading-relaxed opacity-80 sm:text-base">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}
